import { render, staticRenderFns } from "./VerifyForm.vue?vue&type=template&id=54b8efaa"
import script from "./VerifyForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerifyForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports